<v-btn icon class="primary white--text"><v-icon>save</v-icon></v-btn>
<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="(showNewEintrag = true) && (neuerEintrag = {}) && (istNeu = true)" icon v-on="on"
            ><v-icon>add</v-icon></v-btn
          >
        </template>
        <span>Neuer Eintrag</span>
      </v-tooltip>
      Wirtschaftsplan
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
      :headers="headers"
      :items="wirtschaftsplane"
      fixed-header
      hide-default-footer
      :items-per-page="-1"
      :height="sideHeight"
    >
      <template v-slot:item="{ item }">
        <tr @dblclick="(neuerEintrag = item) && (showNewEintrag = true) && (istNeu = false)">
          <td>{{ item.titel }}</td>
          <td>{{ $filters.date(item.datum, "DD.MM.YYYY") }}</td>
          <td>{{ $filters.user(item.erstelltVon, bbrbbr) }}</td>
          <td>{{ $filters.user(item.zuletztBearbeitet, bbrbbr) }}</td>
          <td>
            <v-btn icon @click="print(item)"><v-icon>print</v-icon></v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="showNewEintrag" fullscreen persistent scrollable>
      <v-card>
        <v-card-title>
          <span
            ><v-text-field
              dense
              v-model="neuerEintrag.titel"
              label="Titel"
              hide-details
              outlined
              placeholder="Wirtschaftsplan erstellen"
            ></v-text-field
          ></span>
          <v-btn icon @click="print(neuerEintrag)"><v-icon>print</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="showNewEintrag = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row class="ma-0 pa-0">
            <v-col cols="12" v-for="(position, index) in neuerEintrag.wirtschaftsplan" :key="index">
              <v-card outlined>
                <v-card-title>
                  <v-edit-dialog persistent :return-value.sync="position.titel">
                    {{ index + 1 }}. {{ position.titel }}
                    <template v-slot:input>
                      <v-text-field
                        v-model="position.titel"
                        label="Bezeichnung eintragen"
                        hint="Zum Bestätigen Enter drücken, mit ESC abbrechen."
                        single-line
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="deleteBlock(position)" :disabled="position.positionen.length !== 0"
                    ><v-icon>delete</v-icon></v-btn
                  >
                  <v-btn icon @click="addRow(index)"><v-icon>add</v-icon></v-btn>
                </v-card-title>

                <v-data-table
                  :headers="headersTabelle"
                  :items="position.positionen"
                  fixed-header
                  dense
                  item.key="position.id"
                  hide-default-header
                  hide-default-footer
                  :items-per-page="-1"
                  no-data-text="Keine Einträge"
                >
                  <template v-slot:header="{}">
                    <tr>
                      <th colspan="4">Bezeichnung</th>
                      <th width="2px"><v-divider vertical></v-divider></th>
                      <th class="text-right" width="140px">Soll-Einnahmen</th>
                      <th class="text-right" width="140px">Soll-Ausgaben</th>
                      <th width="2px"><v-divider vertical></v-divider></th>
                      <th class="text-right" width="140px">Ist-Einnahmen</th>
                      <th class="text-right" width="140px">Ist-Ausgaben</th>
                      <th width="2px"><v-divider vertical></v-divider></th>
                      <th class="text-right" width="140px">Differenz</th>
                      <th class="text-right" width="120px"></th>
                      <v-divider></v-divider>
                    </tr>
                    <tr>
                      <th colspan="14">
                        <v-divider></v-divider>
                      </th>
                    </tr>
                  </template>
                  <template v-slot:item="props">
                    <tr v-if="props.item.positionen.length > 0" class="grey lighten-2">
                      <td class="text-left" colspan="4">
                        <v-edit-dialog persistent :return-value.sync="props.item.bezeichnung" @save="onChange()">
                          {{ props.item.bezeichnung }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.bezeichnung"
                              label="Bezeichnung eintragen"
                              hint="Zum Bestätigen Enter drücken, mit ESC abbrechen."
                              single-line
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right">
                        {{ getSum(props.item, "einnahmen") | money }}
                      </td>
                      <td class="text-right">
                        {{ getSum(props.item, "ausgaben") | money }}
                      </td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right">
                        {{ getSum(props.item, "istEinnahmen") | money }}
                      </td>
                      <td class="text-right">
                        {{ getSum(props.item, "istAusgaben") | money }}
                      </td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right">
                        <span v-if="props.item.istEinnahmen || props.item.istAusgaben">
                          {{
                            (props.item.istEinnahmen -
                              props.item.einnahmen -
                              props.item.istAusgaben +
                              props.item.ausgaben)
                              | money
                          }}
                        </span>
                      </td>
                      <td class="text-right">
                        <v-btn icon @click="addGroupRow(props.item, index)"><v-icon>add</v-icon></v-btn>
                        <v-btn icon v-if="props.item.positionen.length === 0" @click="deleteRow(props.item, index)"
                          ><v-icon>delete</v-icon></v-btn
                        >
                        <v-btn icon v-else @click.stop="props.item.show = !props.item.show"
                          ><v-icon>keyboard_arrow_down</v-icon></v-btn
                        >
                      </td>
                    </tr>

                    <tr v-else class="grey lighten-2">
                      <td class="text-left" colspan="4">
                        <v-edit-dialog persistent :return-value.sync="props.item.bezeichnung" @save="onChange()">
                          {{ props.item.bezeichnung }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.bezeichnung"
                              label="Bezeichnung eintragen"
                              hint="Zum Bestätigen Enter drücken, mit ESC abbrechen."
                              single-line
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right">
                        <v-edit-dialog persistent :return-value.sync="props.item.einnahmen" @save="onChange()">
                          {{ props.item.einnahmen | money }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.einnahmen"
                              label="Einnahmen eintragen"
                              hint="Zum Bestätigen Enter drücken, mit ESC abbrechen."
                              single-line
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-right">
                        <v-edit-dialog persistent :return-value.sync="props.item.ausgaben" @save="onChange()">
                          {{ props.item.ausgaben | money }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.ausgaben"
                              label="Ausgaben eintragen"
                              hint="Zum Bestätigen Enter drücken, mit ESC abbrechen."
                              single-line
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right">
                        <v-edit-dialog persistent :return-value.sync="props.item.istEinnahmen" @save="onChange()">
                          {{ props.item.istEinnahmen | money }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.istEinnahmen"
                              label="Ist Einnahmen eintragen"
                              hint="Zum Bestätigen Enter drücken, mit ESC abbrechen."
                              single-line
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-right">
                        <v-edit-dialog persistent :return-value.sync="props.item.istAusgaben" @save="onChange()">
                          {{ props.item.istAusgaben | money }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.istAusgaben"
                              label="Ist Ausgaben eintragen"
                              hint="Zum Bestätigen Enter drücken, mit ESC abbrechen."
                              single-line
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right">
                        <span v-if="props.item.istAusgaben || props.item.istEinnahmen">
                          {{ getDiff(props.item) | money }}
                        </span>
                      </td>
                      <td class="text-right">
                        <v-btn icon @click="addGroupRow(props.item, index)"><v-icon>playlist_add</v-icon></v-btn>
                        <v-btn icon @click="deleteRow(props.item, index)"><v-icon>delete</v-icon></v-btn>
                      </td>
                    </tr>

                    <rowWirtschaftsplan
                      v-if="props.item.show && props.item.positionen"
                      :parent="props.item"
                      :ebene="1"
                      :item="pos"
                      v-for="(pos, index) in props.item.positionen"
                      :key="index"
                    />
                  </template>
                  <template v-slot:body.append="props">
                    <tr class="grey lighten-2">
                      <td width="20px"></td>
                      <td width="20px"></td>
                      <td width="20px"></td>

                      <td class="text-right font-weight-bold">Summe:</td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right font-weight-bold">{{ getSum(position, "einnahmen") | money }}</td>
                      <td class="text-right font-weight-bold">{{ getSum(position, "ausgaben") | money }}</td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right font-weight-bold">{{ getSum(position, "istEinnahmen") | money }}</td>
                      <td class="text-right font-weight-bold">{{ getSum(position, "istAusgaben") | money }}</td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right">
                        {{
                          (parseFloat(getSum(position, "istEinnahmen")) -
                            parseFloat(getSum(position, "einnahmen")) -
                            parseFloat(getSum(position, "istAusgaben")) +
                            parseFloat(getSum(position, "ausgaben")))
                            | money
                        }}
                      </td>
                      <td></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn rounded @click="addBlock()"><v-icon>add</v-icon></v-btn>
            </v-col>

            <!-- ****************************
            Beginn Summentabelle
            **************************** -->
            <v-col cols="12">
              <v-card outlined>
                <v-card-title> Summe </v-card-title>
                <v-simple-table fixed-header dense>
                  <thead>
                    <tr>
                      <th class="text-left" width="80px">Position</th>
                      <th class="text-left">Bezeichnung</th>
                      <th width="2px"><v-divider vertical></v-divider></th>
                      <th class="text-right" width="140px">Soll-Einnahmen</th>
                      <th class="text-right" width="140px">Soll-Ausgaben</th>
                      <th width="2px"><v-divider vertical></v-divider></th>
                      <th class="text-right" width="140px">Ist-Einnahmen</th>
                      <th class="text-right" width="140px">Ist-Ausgaben</th>
                      <th width="2px"><v-divider vertical></v-divider></th>
                      <th class="text-right" width="140px">Differenz</th>
                      <th width="120px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(position, index) in neuerEintrag.wirtschaftsplan" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td class="text-left">{{ position.titel }}</td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right">{{ getSum(position, "einnahmen") | money }}</td>
                      <td class="text-right">{{ getSum(position, "ausgaben") | money }}</td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right">{{ getSum(position, "istEinnahmen") | money }}</td>
                      <td class="text-right">{{ getSum(position, "istAusgaben") | money }}</td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right">{{ getDiff(position) | money }}</td>
                      <td></td>
                    </tr>
                    <tr class="grey lighten-2">
                      <td></td>
                      <td class="text-right font-weight-bold">Endstand:</td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right font-weight-bold">{{ summen[0] | money }}</td>
                      <td class="text-right font-weight-bold">{{ summen[1] | money }}</td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right font-weight-bold">{{ summen[2] | money }}</td>
                      <td class="text-right font-weight-bold">{{ summen[3] | money }}</td>
                      <td><v-divider vertical></v-divider></td>
                      <td class="text-right font-weight-bold">
                        {{ (summen[2] - summen[0] - summen[3] + summen[1]) | money }}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showNewEintrag = false">Abbrechen</v-btn>
          <v-btn v-if="istNeu" class="primary" @click="saveNeuEintrag()" dark text>Erstellen</v-btn>
          <v-btn v-else class="primary" @click="saveEintrag()" dark text>Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import JSPDF from "jspdf";
  export default {
    props: ["kasse"],
    data() {
      return {
        neuerEintrag: {},
        showNewEintrag: false,
        istNeu: undefined,
        headers: [
          { text: "Bezeichnung", value: "bezeichnung" },
          { text: "Stand", value: "datum" },
          { text: "Erstellt von", value: "erstelltVon" },
          { text: "Zuletzt bearbeitet", value: "bearbeitetVon" },
          { text: "", value: "" },
        ],
        headersTabelle: [
          { text: "Position", value: "id" },
          { text: "Bezeichnung", value: "" },
          { text: "", value: "" },
          { text: "", value: "" },
          { text: "", value: "" },
          { text: "Soll-Einnahmen", value: "" },
          { text: "Soll-Ausgaben", value: "" },
          { text: "", value: "" },
          { text: "Ist-Einnahmen", value: "" },
          { text: "Ist-Ausgaben", value: "" },
          { text: "", value: "" },
          { text: "Differenz", value: "" },
          { text: "", value: "" },
        ],
        expanded: [],
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      wirtschaftsplane() {
        if (this.$store.state.wirtschaftsplane.loaded === false) {
          this.$store.dispatch("wirtschaftsplane/loadWirtschaftsplane");
        }
        return this.$store.getters["wirtschaftsplane/wirtschaftsplane"];
      },
      summen() {
        let summen = [0, 0, 0, 0];
        if (this.neuerEintrag.wirtschaftsplan) {
          this.neuerEintrag.wirtschaftsplan.forEach((positionen) => {
            positionen.einnahmen = 0;
            positionen.ausgaben = 0;
            positionen.istEinnahmen = 0;
            positionen.istAusgaben = 0;
            positionen.positionen.forEach((position) => {
              positionen.einnahmen += parseFloat(this.getSum(position, "einnahmen"));
              positionen.ausgaben += parseFloat(this.getSum(position, "ausgaben"));
              positionen.istEinnahmen += parseFloat(this.getSum(position, "istEinnahmen"));
              positionen.istAusgaben += parseFloat(this.getSum(position, "istAusgaben"));
            });
            summen[0] += parseFloat(positionen.einnahmen);
            summen[1] += parseFloat(positionen.ausgaben);
            summen[2] += parseFloat(positionen.istEinnahmen);
            summen[3] += parseFloat(positionen.istAusgaben);
          });
        }
        return summen;
      },
      sideHeight() {
        if (this.$store.state.user.user !== null && this.$store.state.user.user !== undefined) {
          switch (this.$vuetify.breakpoint.name) {
            case "xs":
              return "calc(100vh - 161px)";
            case "sm":
              return "calc(100vh - 149px)";
            case "md":
              return "calc(100vh - 169px)";
            case "lg":
              return "calc(100vh - 225px)";
            case "xl":
              return "calc(100vh - 225px)";
          }
        } else {
          switch (this.$vuetify.breakpoint.name) {
            case "xs":
              return "calc(100vh - 169px)";
            case "sm":
              return "calc(100vh - 169px)";
            case "md":
              return "calc(100vh - 169px)";
            case "lg":
              return "calc(100vh - 169px)";
            case "xl":
              return "calc(100vh - 169px)";
          }
        }
      },
    },
    methods: {
      onChange() {
        console.log("test");
      },
      getSum(item, key) {
        let sum = 0;
        if (item.positionen && item.positionen.length > 0) {
          item.positionen.forEach((pos) => {
            sum += this.getSum(pos, key);
          });
        } else {
          if (key === "istEinnahmen") {
            if (
              (parseInt(item.istEinnahmen) === 0 || item.istEinnahmen === "") &&
              (parseInt(item.istAusgaben) === 0 || item.istAusgaben === "")
            ) {
              sum += parseInt(item.istEinnahmen ? item.istEinnahmen : 0);
            }
          }
          if (key === "istAusgaben") {
            if (
              (parseInt(item.istEinnahmen) === 0 || item.istEinnahmen === "") &&
              (parseInt(item.istAusgaben) === 0 || item.istAusgaben === "")
            ) {
              sum += parseInt(item.istAusgaben ? item.istAusgaben : 0);
            }
          }
          if (key === "einnahmen" || "ausgaben") {
            sum += parseInt(item[key] ? item[key] : 0);
          }
        }
        return sum;
      },
      getDiff(item) {
        let diff = 0;
        diff += parseFloat(item.istEinnahmen ? item.istEinnahmen : 0);
        diff -= parseFloat(item.einnahmen ? item.einnahmen : 0);
        diff -= parseFloat(item.istAusgaben ? item.istAusgaben : 0);
        diff += parseFloat(item.ausgaben ? item.ausgaben : 0);
        return diff;
      },
      saveNeuEintrag() {
        this.neuerEintrag.datum = new Date();
        this.neuerEintrag.erstelltVon = this.currentBbr;
        this.neuerEintrag.zuletztBearbeitet = this.currentBbr;
        this.$store.dispatch("wirtschaftsplane/createWirtschaftsplan", this.neuerEintrag);
        this.neuerEintrag = {};
        this.showNewEintrag = false;
      },
      saveEintrag() {
        this.neuerEintrag.datum = new Date();
        this.neuerEintrag.zuletztBearbeitet = this.currentBbr;
        this.$store.dispatch("wirtschaftsplane/updateWirtschaftsplanData", this.neuerEintrag);
        this.neuerEintrag = {};
        this.showNewEintrag = false;
      },
      addRow(index) {
        this.neuerEintrag.wirtschaftsplan[index].positionen.push({
          bezeichnung: "Neu",
          show: true,
          positionen: [],
          einnahmen: 0,
          ausgaben: 0,
          istEinnahmen: 0,
          istAusgaben: 0,
        });
      },
      deleteRow(item, index) {
        this.neuerEintrag.wirtschaftsplan[index].positionen.splice(
          this.neuerEintrag.wirtschaftsplan[index].positionen.indexOf(item),
          1
        );
      },
      addGroupRow(item) {
        console.log("2");
        if (item.positionen.length === 0) {
          item.positionen.push({
            bezeichnung: item.bezeichnung,
            show: true,
            positionen: [],
            einnahmen: item.einnahmen,
            ausgaben: item.ausgaben,
            istEinnahmen: item.istEinnahmen,
            istAusgaben: item.istAusgaben,
          });
        } else {
          item.positionen.push({
            bezeichnung: "Neu",
            show: true,
            positionen: [],
            einnahmen: 0,
            ausgaben: 0,
            istEinnahmen: 0,
            istAusgaben: 0,
          });
        }
      },
      deleteGroupRow(item, index, index2) {
        this.neuerEintrag.wirtschaftsplan[index].positionen[index2].positionen.splice(
          this.neuerEintrag.wirtschaftsplan[index].positionen[index2].positionen.indexOf(item),
          1
        );
      },
      addBlock() {
        if (this.neuerEintrag.wirtschaftsplan === undefined) {
          this.neuerEintrag.wirtschaftsplan = [];
        }
        this.neuerEintrag.wirtschaftsplan.push({
          titel: "",
          positionen: [],
          ausgaben: 0,
          einnahmen: 0,
          istEinnahmen: 0,
          istAusgaben: 0,
        });
      },
      deleteBlock(item) {
        this.neuerEintrag.wirtschaftsplan.splice(this.neuerEintrag.wirtschaftsplan.indexOf(item), 1);
      },
      clickRow(value) {
        console.log(this.expanded);
        const index = this.expanded.indexOf(value);
        if (index === -1) {
          this.expanded = [];
          this.expanded.push(value);
        } else {
          this.expanded.splice(index, 1);
        }
      },
      print(item) {
        console.log("print");
        let doc = new JSPDF({
          orientation: "p",
          unit: "mm",
          format: "a3",
        });
        const links = 20;
        // const rechts = 297 - 25
        // const breite = 297 - 50

        console.log(doc.getFontList());
        doc.setFont("Courier");
        doc.setFillColor(39, 84, 165);
        doc.rect(0, 0, 297, 30, "F");

        doc.setFontSize(32);
        doc.setTextColor(255, 255, 255);
        doc.text(20, 25, item.titel);
        doc.setFontSize(9);
        doc.text(
          277,
          25,
          new Date().toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          }) + " Uhr",
          { align: "right" }
        );
        doc.setTextColor(0, 0, 0);
        let zeile = 50;

        item.wirtschaftsplan.forEach((block, index) => {
          let start = zeile;
          doc.setFillColor("#2196F3");
          doc.roundedRect(15, start - 8, 267, 19, 3, 3, "F");
          doc.rect(15, start, 267, 11, "F");
          doc.setFontSize(20);
          doc.text(20, zeile, index + 1 + ". " + block.titel);
          zeile += 8;
          doc.setFontSize(9);
          doc.setFont("Courier", "bold");
          doc.text("Bezeichnung", links, zeile, { align: "left" });
          doc.text("Soll-Einnahmen", 150, zeile, { align: "right" });
          doc.text("Soll-Ausgaben", 180, zeile, { align: "right" });
          doc.text("Ist-Einnahmen", 210, zeile, { align: "right" });
          doc.text("Ist-Ausgaben", 240, zeile, { align: "right" });
          doc.text("Differenz", 270, zeile, { align: "right" });
          doc.setFont("Courier", "normal");
          doc.setTextColor(0, 0, 0);
          zeile += 8;
          block.positionen.forEach((pos) => {
            zeile = this.drawPosition(doc, pos, zeile, links, 1);
          });
          doc.setFillColor("#2196F3");
          doc.setDrawColor("#2196F3");
          doc.rect(15, zeile - 5, 267, 5, "F");
          doc.roundedRect(15, zeile - 5, 267, 10, 3, 3, "F");
          doc.setFont("Courier", "bold");
          doc.text("Summe", links, zeile, { align: "left" });
          doc.text(parseFloat(this.getSum(block, "einnahmen")).toFixed(2) + " €", 150, zeile, { align: "right" });
          doc.text(parseFloat(this.getSum(block, "ausgaben")).toFixed(2) + " €", 180, zeile, { align: "right" });
          doc.text(parseFloat(this.getSum(block, "istEinnahmen")).toFixed(2) + " €", 210, zeile, { align: "right" });
          doc.text(parseFloat(this.getSum(block, "istAusgaben")).toFixed(2) + " €", 240, zeile, { align: "right" });
          doc.text("", 270, zeile, { align: "right" });
          doc.setFont("Courier", "normal");
          zeile += 10;
          doc.roundedRect(15, start - 8, 267, zeile - start + 3, 3, 3, "S");
          zeile += 10;
        });

        doc.save("Wirtschaftsplan.pdf");
      },
      drawPosition(doc, position, zeile, links, ebene) {
        doc.setFontSize(10);
        if (ebene === 1) {
          doc.setFillColor("#BBDEFB");
          doc.rect(15, zeile - 5, 267, 10, "F");
        }
        doc.text(links, zeile, position.bezeichnung);
        if (position.positionen) {
          doc.text(parseFloat(this.getSum(position, "einnahmen")).toFixed(2) + " €", 150, zeile, { align: "right" });
          doc.text(parseFloat(this.getSum(position, "ausgaben")).toFixed(2) + " €", 180, zeile, { align: "right" });
          doc.text(parseFloat(this.getSum(position, "istEinnahmen")).toFixed(2) + " €", 210, zeile, { align: "right" });
          doc.text(parseFloat(this.getSum(position, "istAusgaben")).toFixed(2) + " €", 240, zeile, { align: "right" });
        } else {
          if (position.einnahmen !== 0 && position.einnahmen !== "") {
            doc.text(parseFloat(position.einnahmen).toFixed(2) + " €", 150, zeile, { align: "right" });
          } else {
            doc.text("-", 150, zeile, { align: "right" });
          }
          if (position.ausgaben !== 0 && position.ausgaben !== "") {
            doc.text(parseFloat(position.ausgaben).toFixed(2) + " €", 180, zeile, { align: "right" });
          } else {
            doc.text("-", 180, zeile, { align: "right" });
          }
          if (position.istEinnahmen !== 0 && position.istEinnahmen !== "") {
            doc.text(parseFloat(position.istEinnahmen).toFixed(2) + " €", 210, zeile, { align: "right" });
          } else {
            doc.text("-", 210, zeile, { align: "right" });
          }
          if (position.istAusgaben !== 0 && position.istAusgaben !== "") {
            doc.text(parseFloat(position.istAusgaben).toFixed(2) + " €", 240, zeile, { align: "right" });
          } else {
            doc.text("-", 240, zeile, { align: "right" });
          }
        }
        if (position.istEinnahmen !== 0 || position.istAusgaben !== 0) {
          doc.text(parseFloat(this.getDiff(position)).toFixed(2) + " €", 270, zeile, { align: "right" });
        } else {
          doc.text("-", 270, zeile, { align: "right" });
        }
        zeile += 10;

        // Überprüfen, ob die Position Unterpositionen hat
        if (position.positionen.length > 0) {
          position.positionen.forEach((subpos) => {
            // Rekursiver Aufruf für Unterpositionen
            zeile = this.drawPosition(doc, subpos, zeile, links + 10, ebene + 1);
          });
        }
        return zeile;
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// wirtschaftsplan.vue?60bde8e6